import useAgency from 'features/Agency/useAgency';
import ChargeHelper, { ChargeConstants } from 'features/Charge/chargeHelper';
import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import KTFormInput, {
  KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import CustomDropdown2 from 'general/components/Others/CustomDropdown2';
import AppColors from 'general/constants/AppColors';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useRef, useState } from 'react';
import QRCode from 'react-qr-code';

DialogAddRfidCardView.propTypes = {
  item: PropTypes.object,
  taggingMode: PropTypes.bool,
  onCancel: PropTypes.func,
  onDone: PropTypes.func,
};

function DialogAddRfidCardView({ item, taggingMode = false, onCancel, onDone }) {
  // MARK: ---- PROPERTIES ----
  const editMode = !!item;
  const { operatorList } = useAgency();
  const qrRef = useRef(null);
  const [selectedOperator, setSelectedOperator] = useState(null);
  useEffect(() => {
    if (operatorList?.length > 0) {
      setSelectedOperator(operatorList[0]);
    }
  }, [operatorList]);
  const [readyToValidate, setReadyToValidate] = useState(false);
  const [idTag, setIdTag] = useState('');
  const [serialNumber, setSerialNumber] = useState('');
  const [vehicleId, setVehicleId] = useState(null);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [loading, setLoading] = useState(false);
  const dropdownVehicleEl = useMemo(() => {
    return (
      <CustomDropdown2
        id="vehicleId_dialog"
        name="vehicleId_dialog"
        ignoreConfirmClick={true}
        toggleElement={
          <button
            className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between`}
            type="button"
          >
            {selectedVehicle?.name ?? 'Chọn xe'}
          </button>
        }
        selectedValue={selectedVehicle}
        dropdownMenuItems={[{ name: 'Xe', role: 'VEHICLE' }]}
        getSubItems={async (item) => {
          return ChargeHelper.API.Vehicle.requestGetVehicleList({
            page: item?.page || 0,
            limit: 10,
            q: item?.q || '',
          }).then((data) => {
            return {
              values: data.vehicles?.map((row) => ({
                id: row?.vehicleId,
                name: row?.plate,
                item: row,
              })),
              total: data.total,
            };
          });
        }}
        dropdownMenuStyle={{ maxHeight: '30vh' }}
        dropdownMenuClassName="overflow-auto w-100"
        onChange={(value) => {
          setSelectedVehicle(value);
          setVehicleId(value?.id);
        }}
        isDropdownForm={true}
        titleSearchable={true}
        searchable={true}
        searchFormClassName="mx-3 my-1 search-form-border"
        defaultValue={{
          name: 'Xe',
          role: 'VEHICLE',
        }}
        footerEl={
          <div
            className="p-4 position-sticky sticky-bottom bg-white"
            style={{
              borderTop: `1px solid ${AppColors.gray[300]}`,
            }}
          >
            {UIHelper.buildNegativeButton('Bỏ chọn', () => {
              setSelectedVehicle(null);
              setVehicleId(null);
            })}
          </div>
        }
      />
    );
  }, [selectedVehicle, readyToValidate]);
  useEffect(() => {
    if (item) {
      setIdTag(item?.idTag);
      setVehicleId(item?.vehicleId);
      setSerialNumber(item?.serialNumber);
      if (item?.vehicle) {
        setSelectedVehicle({
          id: item?.vehicle?.vehicleId,
          name: item?.vehicle?.plate,
          item: item?.vehicle,
        });
      }
    }
  }, [item]);

  // MARK: ---- METHODS ----
  const handleSubmit = async () => {
    setReadyToValidate(true);
    if (!idTag) {
      ToastHelper.showError('Bạn chưa nhập đủ thông tin');
      return;
    }
    let params = {
      idTag: idTag,
      vehicleId: vehicleId,
      serialNumber: serialNumber,
    };
    console.log({ params });
    const selectedVehicleCards = selectedVehicle?.item?.cards;
    setLoading(true);
    if (editMode) {
      ChargeHelper.API.RFID.requestUpdateRFIDCard(item?.rfidId, params)
        .then((res) => {
          // thu hoi tat ca ca the RFID cu cua xe dang duoc chon
          if (selectedVehicleCards?.length > 0) {
            selectedVehicleCards.forEach((card) => {
              ChargeHelper.API.RFID.requestUpdateRFIDCard(card?.rfidId, {
                vehicleId: null,
              });
            });
          }

          ToastHelper.showSuccess('Cập nhật thẻ RFID thành công');
          if (onDone) onDone();
        })
        .catch((error) => {
          ToastHelper.showError('Có lỗi xảy ra');
        })
        .finally(() => {
          setLoading(false);
        });
      return;
    } else {
      ChargeHelper.API.RFID.requestAddRFIDCard({
        ...params,
        status: ChargeConstants.RFIDCardStatus.NORMAL,
        operatorId: selectedOperator?.operatorId,
      })
        .then((res) => {
          if (_.isBoolean(res) && res) {
            ToastHelper.showSuccess('Thêm thẻ RFID thành công');
            if (onDone) onDone();
          } else if (_.isString(res)) {
            ToastHelper.showError(res);
          }
        })
        .catch((error) => {
          ToastHelper.showError('Có lỗi xảy ra');
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const downloadQRCode = () => {
    const svg = qrRef.current?.querySelector('svg');
    if (!svg) return;

    const OUTPUT_SIZE = 8192;
    const PADDING_RATIO = 0.05;

    const svgClone = svg.cloneNode(true);
    const bbox = svg.getBBox();
    const qrSize = Math.max(bbox.width, bbox.height);
    const paddedSize = qrSize / (1 - 2 * PADDING_RATIO);
    const scale = OUTPUT_SIZE / paddedSize;
    const finalSize = paddedSize * scale;

    svgClone.setAttribute('width', finalSize.toString());
    svgClone.setAttribute('height', finalSize.toString());
    svgClone.setAttribute('viewBox', `0 0 ${paddedSize} ${paddedSize}`);

    const g = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    g.setAttribute('transform', `translate(${paddedSize * PADDING_RATIO}, ${paddedSize * PADDING_RATIO})`);
    while (svgClone.firstChild) g.appendChild(svgClone.firstChild);
    svgClone.appendChild(g);

    const svgData = new XMLSerializer().serializeToString(svgClone);
    const url = URL.createObjectURL(new Blob([svgData], { type: 'image/svg+xml' }));

    const canvas = document.createElement('canvas');
    canvas.width = Math.round(finalSize);
    canvas.height = Math.round(finalSize);
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    ctx.imageSmoothingEnabled = false;

    const img = new Image();
    img.onload = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      canvas.toBlob(blob => {
        if (!blob) return;
        const pngUrl = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = pngUrl;
        a.download = `QR-NapTien-${serialNumber}.png`;
        a.click();
        URL.revokeObjectURL(pngUrl);
        URL.revokeObjectURL(url);
      }, 'image/png');
    };
    img.src = url;
  };

  return (
    <div>
      <div className="row m-0 p-0 px-2 mt-4">
        {/* ma id tag */}
        {!taggingMode && (
          <div className="col-12 mb-4 px-2">
            <div>
              {UIHelper.buildFormLabel('Mã ID Tag', true)}
              <KTFormInput
                type={KTFormInputType.text}
                placeholder="Nhập mã ID Tag"
                name="idTag"
                value={idTag}
                onChange={(value) => {
                  setIdTag(value);
                }}
                enableCheckValid={true}
                isValid={Utils.isValid(idTag)}
                isTouched={readyToValidate}
              />
            </div>
          </div>
        )}

        {/* xe */}
        <div className="col-12 mb-4 px-2">
          <div>
            {UIHelper.buildFormLabel('Chọn xe')}
            {dropdownVehicleEl}
          </div>
        </div>

        <div className="col-12 mb-4 px-2">
          <div style={{ borderTop: `1px dashed ${AppColors.gray[300]}` }} />
        </div>

        {/* so serial */}
        <div className="col-12 mb-4 px-2">
          <div>
            {UIHelper.buildFormLabel('Số serial nạp tiền')}
            <KTFormInput
              type={KTFormInputType.text}
              placeholder="Nhập số serial"
              name="serialNumber"
              value={serialNumber}
              onChange={(value) => {
                setSerialNumber(value);
              }}
              enableCheckValid={true}
              isValid={Utils.isValid(serialNumber)}
              isTouched={readyToValidate}
            />
          </div>
        </div>

        {/* ma qr */}
        {!_.isEmpty(serialNumber) && (
          <>
            <div className="col-4 mb-4 px-2">
              {UIHelper.buildFormLabel('Mã QR-Nạp tiền')}
              <div ref={qrRef} style={{ border: `1px solid #DBDFF1B2` }}
                className="d-flex flex-row gap-3 cursor-pointer hover-opacity-60 rounded p-2"
                onClick={() => {
                  AppCustomDialogHelper.show(
                    `Mã QR-Nạp tiền`,
                    <div className="p-4">
                      <QRCode
                        value={ChargeHelper.Utils.getRFIDQRCodeLink(serialNumber)}
                        size={'100%'}
                        bgColor="none"
                      />
                    </div>,
                    'md',
                    true,
                    true
                  );
                }}
              >
                <QRCode
                  id="qrCode"
                  value={ChargeHelper.Utils.getRFIDQRCodeLink(serialNumber)}
                  size={'100%'}
                  renderAs="canvas"
                  bgColor="none"
                />
              </div>
            </div>
            <div className="col-4 mb-4 pl-0 d-flex align-items-end">
              {UIHelper.buildNegativeButton(
                'Tải xuống',
                downloadQRCode,
                <i className="fa-regular fa-download" style={{ color: '#494968' }} />
              )}
            </div>
          </>
        )}
      </div>

      {/* footer */}
      <div
        className="d-flex align-items-center justify-content-end gap-3 px-4 py-3"
        style={{
          borderTop: `1px solid ${AppColors.gray[200]}`,
        }}
      >
        {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null, true)}
        {UIHelper.buildGreenButton(
          !editMode ? 'Thêm' : 'Cập nhật',
          handleSubmit,
          null,
          true,
          loading
        )}
      </div>
    </div>
  );
}

export default DialogAddRfidCardView;
